import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

/**
 * Dialog to create/edit revenue management related contract details
 */
function RevenueManagementDialog({ data, isNew, close }) {
  return (
    <Dialog maxWidth="lg" onClose={close} open>
      <DialogTitle>
        {isNew
          ? 'Create partner contract entry'
          : 'Edit partner contract entry'}
      </DialogTitle>
      <DialogContent>
        {data?.id ? JSON.stringify(data, null, 2) : 'No data'}
      </DialogContent>
    </Dialog>
  );
}

RevenueManagementDialog.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
  }),
  isNew: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default RevenueManagementDialog;
